import _ from "lodash";
import styled from "styled-components";
import { breakpoint } from "@utilities";
import { BookingPrice } from "@interfaces";

interface IProps {
    faresPrices: BookingPrice[];
}

export const ProductPriceMessage = ({ faresPrices }: IProps) => {
    const prices = _.map(faresPrices, (fp) => fp.rrp);
    const hasVariablePricing = _.uniq(prices).length > 1;
    const priceMessage = hasVariablePricing
        ? `$${_.min(prices)?.toFixed(2)}`
        : `$${prices.at(0)?.toFixed(2)}`;

    return (
        <StyledPrice className="price">
            {hasVariablePricing && "From"}
            <PriceSpan>{priceMessage}</PriceSpan>
        </StyledPrice>
    );
};

const StyledPrice = styled.div`
    display: flex;
    align-items: center;
    
    ${breakpoint.breakMobile`
        flex-direction: column;
        align-items: flex-start;
    `}
`;

const PriceSpan = styled.span`
    margin-left: 12px;
    
    ${breakpoint.breakMobile`
        margin-left: 0;
        margin-top: 4px;
    `}
`;